import { render, staticRenderFns } from "./AppSelect.vue?vue&type=template&id=5ac785fe&scoped=true"
import script from "./AppSelect.vue?vue&type=script&lang=js"
export * from "./AppSelect.vue?vue&type=script&lang=js"
import style0 from "./AppSelect.vue?vue&type=style&index=0&id=5ac785fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac785fe",
  null
  
)

export default component.exports